import React from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import Table from '../../common/Table';

import { showModal } from '../../../actions/modal';
import { fetchDeleteUserRole } from '../../../actions/settings';

import { parseError } from '../../../helpers';

import { USERS_SETTINGS_COUNT_ON_PAGE } from '../../../config';
import { USER_PRIVILEGES } from '../../../config/privileges';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const getPrivilegesString = (privileges) => {
  const isAdmin = privileges.find((p) => p === 'ADMIN');
  if (isAdmin) {
    return USER_PRIVILEGES['ADMIN'];
  }

  return privileges.map((p) => USER_PRIVILEGES[p]).join(', ');
};

const RolesTable = (props) => {
  const { roles, users, actualizeData } = props;

  const { t } = useAutoTranslation();

  const dispatch = useDispatch();

  const handleNewRole = () => {
    dispatch(
      showModal('EditUserRole', {
        users,
        roles,
        submitCallback: actualizeData,
      }),
    );
  };

  const handleEditRole = (currentRole) => {
    dispatch(
      showModal('EditUserRole', {
        currentRole,
        users,
        roles,
        submitCallback: actualizeData,
      }),
    );
  };

  const handleDeleteRole = (role) => {
    dispatch(
      showModal('Confirm', {
        body: `${t('Подтвердите удаление роли пользователя')} "${role.name}"`,

        handleConfirm: async () => {
          await dispatch(fetchDeleteUserRole(role.id)).catch((err) => {
            toast.error(parseError(err));
            throw err;
          });

          await actualizeData();
          toast.info(t('Роль успешно удалена'));
        },

        confirmBtnTitle: t('Удалить'),
      }),
    );
  };

  const data = {
    cols: [t('Роль'), t('Привилегии')],
    rows: roles.map((r) => ({
      key: r.id,
      item: r,
      data: [
        {
          value: r.name,
          editItem: true,
        },
        { value: getPrivilegesString(r.privileges) },
      ],
      isEditable: !r.isSystemRole,
      isRemovable: !r.isSystemRole,
    })),
  };

  return (
    <Table
      id="userRoles"
      className="mt-4"
      smallTitle={t('Роли и привилегии')}
      data={data}
      creatable
      createLabel={t('Новая роль')}
      removable
      pagination
      perPage={USERS_SETTINGS_COUNT_ON_PAGE}
      handleNewItem={handleNewRole}
      handleEditItem={handleEditRole}
      handleRemoveItem={handleDeleteRole}
    />
  );
};

export default RolesTable;
